module.exports = __webpack_public_path__ + "static/img/sensor_optico_tcrt5000-2.4c51f0b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/sensor_optico_tcrt5000-2.svg
// module id = StCA
// module chunks = 0